export default __webpack_public_path__ + "static/media/Logo_loc.648e60a2.png";